import { Http, Response } from "@angular/http";
import { AuthHttp } from "angular2-jwt";
import { EbFavori } from "../classes/favori";
import { Statique } from "../utils/statique";
import { Injectable } from "@angular/core";
import { EbUser } from "../classes/user";
import { Subject } from "rxjs";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FavoriService {

	private notifyComponent = new Subject<any>();
	private notifyListingComponent = new Subject<any>();

	favorisObservale = this.notifyComponent.asObservable();
	listingFavorisObservale = this.notifyListingComponent.asObservable();

	public notifyComponentFavori(data:any) {
		this.notifyComponent.next(data);
	}

	public notifyListingComponentFavori(data:any) {
		this.notifyListingComponent.next(data);
	}

	constructor(private http: Http, private authHttp: AuthHttp) { }

	addOrRemoveFavori(listFavoris: Map<number, EbFavori>, idObject: number,refObject: string, module: number, userConnected: EbUser, event: HTMLElement) {
		if (listFavoris.has(idObject)) {
			let ebFavori = listFavoris.get(idObject);
			this.deleteFavori(ebFavori).subscribe((data) => {
				listFavoris.delete(idObject);
				event.classList.remove("fa-star");
				event.classList.add("fa-star-o");
				ebFavori.toAdd = false;
				ebFavori.toDelete = true;
				this.notifyComponentFavori(ebFavori);
			});
		}
		else {
			let ebFavori: EbFavori = new EbFavori();
			ebFavori.idObject = idObject;
			ebFavori.refObject = refObject;
			ebFavori.module = module;
			ebFavori.user.ebUserNum = userConnected.ebUserNum;
			this.addFavori(ebFavori).subscribe((data:EbFavori) => {
				listFavoris.set(idObject, data);
				event.classList.remove("fa-star-o");
				event.classList.add("fa-star");
				data.toDelete = false;
				data.toAdd = true;
				this.notifyComponentFavori(data);
			});
		}

	}

	getHtmlFavoris(listFavoris: Map<number, EbFavori>, idObject: number,refObject :string ) {
		let style = "font-size: 20px;cursor: pointer;";
		let _class = "fa fa-star-o";
		if (listFavoris.has(idObject)) _class += "fa fa-star";
		return "<i id="+refObject+" class='" + _class + "' style='" + style + "' onclick='functions.clickFavori(" + idObject + ",\""+refObject+"\",event.target)'></i>"

	}

	addFavori(ebFavori: EbFavori) {
		return this.authHttp.post(Statique.controllerAccount + '/add-favori', ebFavori)
			.map(res => res.json());
	}


	deleteFavori(ebFavori: EbFavori) {
		return this.authHttp.post(Statique.controllerAccount + '/delete-favori', ebFavori)
			.map((res: Response) => res.json());
	}

	getListFavoris(dataSource: string) {
		return this.authHttp.get(dataSource).map((res: Response) => (res['_body'] != "") ? res.json() : null);
	}
}






// WEBPACK FOOTER //
// ./src/app/services/favori.service.ts